import { render, staticRenderFns } from "./leadsQunSide.vue?vue&type=template&id=1694545e&scoped=true&"
import script from "./leadsQunSide.vue?vue&type=script&lang=js&"
export * from "./leadsQunSide.vue?vue&type=script&lang=js&"
import style0 from "./leadsQunSide.vue?vue&type=style&index=0&id=1694545e&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1694545e",
  null
  
)

export default component.exports